import styled from "styled-components";
import TextDotDivider from "../components/TextDotDivider";

import {useEffect, useState} from "react";
import {fetchQuillData} from "../serverAPI";
import dompurify from "dompurify";

const Header = styled.p`
  font-size: 20px;
  font-family: signika, sans-serif;
  font-weight: bold;
  color: rgb(232, 26, 62);
`;

const HeaderText = styled.p`
  color: rgb(102, 102, 102);
  line-height: 1.5em;
  font-family: Arial, sans-serif;
`;

const BodyText = styled.p`
  font-size: 15px;
  line-height: 1.5em;
`;

const FlexContainer = styled.div`
  display: flex;
`;

const SanitizerInner = styled.div`
  text-align: justify;
  margin-bottom: 50px;

  span {
    line-height: 1.5em;
  }

  & img {
    max-width: 100%;
  }
`;

export default function Research() {
  const sanitizer = dompurify.sanitize;
  const [research, setResearch] = useState("");

  useEffect(() => {
    const loadResearchQuillData = async () => {
      const quillData = await fetchQuillData("research");
      setResearch(quillData);
    };
    loadResearchQuillData();
  }, []);

  return (<div>
    <TextDotDivider text="Research"/>
    <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(research)}}/>

    {/*<HeaderText>Broad research interests of magnetic resonance imaging (MRI) laboratory at*/}
    {/*  Korea Advanced Institute of Science*/}
    {/*  and Technology (KAIST) lie in <span style={{fontWeight: "bold"}}>(i) developing new MRI techniques of image acquisition, processing, and analysis,*/}
    {/*  (ii) revealing brain waste clearance pathway and mechanism through neurofluid MRI, (iii) applying deep learning*/}
    {/*  algorithms to MRI acceleration, image analysis and synthesis, and clinical diagnosis.</span> These technical*/}
    {/*  developments*/}
    {/*  can make big differences in understanding baseline and functional brain physiology, and also diagnosis / prognosis*/}
    {/*  / treatment of our body.</HeaderText>*/}
    {/*<Header>1) MR Imaging of Neurofluid to Reveal Brain Waste Clearance Pathways and Mechanisms</Header>*/}
    {/*<BodyText>Dementia research has traditionally focused on toxic proteins such as beta-amyloid and tau, yet the exact*/}
    {/*  mechanisms through which the brain expels these toxic waste materials remain unclear. While for centuries it was*/}
    {/*  believed that the brain lacked lymphatic vessels, the discovery of meningeal lymphatic vessels in the brain,*/}
    {/*  revealed in a 2015 Nature paper, has sparked global interest and activation of research into brain waste*/}
    {/*  clearance. Although it is generally anticipated that brain waste is transported from the brain's interior*/}
    {/*  lymphatic system to cerebrospinal fluid and then expelled through meningeal lymphatic vessels, several models*/}
    {/*  exist to explain this process. However, challenges persist in accurately describing the mechanism due to numerous*/}
    {/*  inconsistencies in experimental data and flow dynamics perspectives. One of the difficulties in studying brain*/}
    {/*  waste clearance is the slow flow of the associated lymphatic system, cerebrospinal fluid, and lymphatic system,*/}
    {/*  making visualization challenging. Additionally, quantifying flow or pulsatility to understand the waste clearance*/}
    {/*  function is an even more challenging task. Specifically, direct contrast agent injection through cerebrospinal*/}
    {/*  fluid is not permitted in many countries, including South Korea and the United States, making the development of*/}
    {/*  non-invasive imaging techniques crucial. Overcoming these limitations through the development of new non-invasive*/}
    {/*  imaging techniques can provide a precise understanding of brain waste clearance mechanisms in humans. This*/}
    {/*  advancement has the potential to be utilized in the early detection and treatment of neurodegenerative brain*/}
    {/*  conditions, such as dementia. For this, we are developing new non-Invasive imaging techniques for systematic and*/}
    {/*  quantitative measurement of brain waste clearance in humans and animals. Specifically, we develop non-invasive*/}
    {/*  imaging techniques enabling quantitative measurement of the functions of the meningeal lymphatic system,*/}
    {/*  cerebrospinal fluid, and glymphatic system.</BodyText>*/}
    {/*<FlexContainer>*/}
    {/*  <img style={{width: "377px", height: "523px"}} src={research1} alt="image"/>*/}
    {/*  <div>*/}
    {/*    <img style={{width: "408px", height: "258px"}} src={research2} alt="image"/>*/}
    {/*    <img style={{width: "352px", height: "283px"}} src={research3} alt="image"/>*/}
    {/*  </div>*/}
    {/*</FlexContainer>*/}

    {/*<Header>2) Physiological, Metabolic, and Functional MRI</Header>*/}
    {/*<BodyText>Noninvasive visualization of blood vessels, blood flow, blood permeability, and blood oxygenation level*/}
    {/*  dependence is an important step toward understanding sources of brain diseases and brain function. We are*/}
    {/*  developing methods to image both arteries and veins within a single MRI acquisition without compromising their*/}
    {/*  image qualities, map blood perfusion in brain and kidney noninvasively, and map brain function with high spatial*/}
    {/*  resolutions. These techniques have been used to understand diseases such as brain tumors and stroke, map renal*/}
    {/*  function noninvasively, and understand signal sources of high-resolution functional MRI. Also, we have been*/}
    {/*  improving the image quality of single-shot echo planar imaging (EPI), which is typically used for the*/}
    {/*  physiological, metabolic, and functional MRI.</BodyText>*/}
    {/*<FlexContainer>*/}
    {/*  <div>*/}
    {/*    <img style={{width: "473px", height: "252px"}} src={research4} alt="image"/>*/}
    {/*    <img style={{width: "473px", height: "262px"}} src={research5} alt="image"/>*/}
    {/*  </div>*/}
    {/*  <img style={{width: "422px", height: "600px"}} src={research6} alt="image"/>*/}
    {/*</FlexContainer>*/}

    {/*<Header>3) Deep Learning for MRI Acceleration</Header>*/}
    {/*<BodyText>Deep learning has been of interest to many research areas and one of the hottest applications is*/}
    {/*  biomedical*/}
    {/*  imaging. We are trying to develop and apply deep learning algorithms for MRI artifacts suppression, denoising, and*/}
    {/*  fast MRI data acquisition. Simulation-based physics-informed neural network is an interesting approach that does*/}
    {/*  not require a separate measurement of ground truth, and thus has high generalization ability and wide*/}
    {/*  applicability. Also, quantitative mapping of tissue parameters require long processing time, which can be*/}
    {/*  significantly reduced using deep learning.</BodyText>*/}
    {/*<img style={{width: "871px", height: "566px"}} src={research7} alt="image"/>*/}
    {/*<img style={{width: "803px", height: "544px"}} src={research8} alt="image"/>*/}

    {/*<Header>4) Deep Learning for Image Segmentation and Synthesis and Disease Diagnosis</Header>*/}
    {/*<BodyText>Deep learning finds applications in image analysis including segmentation of organs and lesions, image*/}
    {/*  synthesis,*/}
    {/*  and diagnosis of various diseases. Our focus involves developing and applying deep learning algorithms for*/}
    {/*  segmentation, diagnosis/prognosis/treatment planning and monitoring of various diseases. Notably, Huan Minh Luu*/}
    {/*  won first place in the 2021 Brain Tumor Segmentation Challenge (BRATS) among 2200 competitors*/}
    {/*  worldwide.</BodyText>*/}
    {/*<img style={{width: "871px", height: "525px"}} src={research9} alt="image"/>*/}

    {/*<Header>5) Biomedical Applications</Header>*/}
    {/*<BodyText>We have tried to integrate all these imaging techniques for multi-parametric assessment of various brain*/}
    {/*  diseases. We believe combination of the various aspects of the brain would provide much more accurate information*/}
    {/*  than conventional approaches. Also we expect this approach can stimulate interdisciplinary collaborative studies*/}
    {/*  involving engineers, neuroscientists, and clinicians.</BodyText>*/}
    {/*<FlexContainer>*/}
    {/*  <img style={{width: "300px", height: "343px"}} src={research10} alt="image"/>*/}
    {/*  <img style={{width: "555px", height: "350px"}} src={research11} alt="image"/>*/}
    {/*</FlexContainer>*/}
  </div>);
}
